import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Feedback } from 'interface'
import axiosClient from 'utils/axiosClient'

const initialState: { list: Feedback[]; lockItem: number } = {
  list: [],
  lockItem: -1,
}

export const getAll = createAsyncThunk('Feedback/getAll', async () => {
  const { data } = await axiosClient.get('/api/feedback')
  return data
})
export const getOne = createAsyncThunk(
  'Feedback/getOne',
  async (id: string | number) => {
    const { data } = await axiosClient.get('/api/feedback/' + id)
    return data
  }
)

export const FeedbackSlice = createSlice({
  name: 'Feedback',
  initialState,
  reducers: {
    removeItem(state, { payload }: PayloadAction<number>) {
      const index = state.list.findIndex((f) => f.id === payload)
      if (index >= 0) {
        // state.list[index].active = false
        state.list.splice(index, 1)
      }
    },
    lockItem(state, { payload }: PayloadAction<number>) {
      state.lockItem = payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAll.fulfilled, (state, { payload }) => {
      state.list = payload
    })
    builder.addCase(getOne.fulfilled, (state, { payload }) => {
      const index = state.list.findIndex((f) => f.id === payload.id)
      if (index >= 0) {
        state.list.splice(index, 1, payload)
      } else {
        state.list.unshift(payload)
      }
    })
  },
})

export const FeedbackAction = FeedbackSlice.actions

export const FeedbackReducer = FeedbackSlice.reducer
